import cardIcon from "../assets/card.svg";
import idramIcon from "../assets/idram.svg";
import telcellIcon from "../assets/telcell.svg";
import fastshiftIcon from "../assets/fastshift.svg";
import paylinkIcon from "../assets/card-paylink.svg";
import { getTranslation } from "./translate.js";

/**
 * Get payment type translation
 * @param {string} paymentType - Payment type
 * @param {string} language - Current language
 * @returns {string} Translated payment type
 */
export const getTranslatedPaymentType = (paymentType, language) => {
    const translations = {
        CARD: getTranslation("orderPage.card", language),
        CARD_ON_DELIVERY: getTranslation("orderPage.card_on_delivery", language),
        IDRAM: getTranslation("orderPage.idram", language),
        TELCELL: getTranslation("orderPage.telcell", language),
        FASTSHIFT: getTranslation("orderPage.fastshift", language),
        PAYLINK: getTranslation("orderPage.paylink", language),
        CASH: getTranslation("orderPage.cash", language),
        B2B: getTranslation("orderPage.b2b", language)
    };

    return translations[paymentType] || getTranslation("common.unknown", language);
};

/**
 * Get payment icon URL
 * @param {string} paymentType - Payment type
 * @returns {string} Icon URL
 */
export const getPaymentIconUrl = (paymentType) => {
    const icons = {
        CARD: cardIcon,
        CARD_ON_DELIVERY: cardIcon,
        IDRAM: idramIcon,
        TELCELL: telcellIcon,
        FASTSHIFT: fastshiftIcon,
        PAYLINK: paylinkIcon,
        CASH: null, // Cash doesn't have an icon
        B2B: null // B2B uses the cash icon
    };

    return icons[paymentType] || null;
};

/**
 * Get payment icon className
 * @param {string} paymentType - Payment type
 * @returns {string} CSS class name
 */
export const getPaymentIconClassName = (paymentType) => {
    const classNames = {
        CASH: "w-8 h-5",
        B2B: "w-8 h-5",
        TELCELL: "w-14 h-3",
        CARD: "w-8 h-5",
        CARD_ON_DELIVERY: "w-8 h-5",
        IDRAM: "w-8 h-5",
        FASTSHIFT: "w-8 h-5",
        PAYLINK: "w-8 h-5"
    };

    return classNames[paymentType] || "w-8 h-5";
};

